import { gallery } from '@store/index'
import { useSetRecoilState, useResetRecoilState, useRecoilValue } from 'recoil'
import { useCallback } from 'react'
import { concat, filter, find } from 'lodash-es'

export default function useGallery() {

  const state = useRecoilValue(gallery)
  const setGalleryState = useSetRecoilState(gallery)
  const resetGalleryState = useResetRecoilState(gallery)

  // 显示图片查看器
  const showGallery = useCallback(({ house, images, floorPlanImages, imageTagTidy, address, index = 0 }) => {
    return event => {

      event.preventDefault()
      event.stopPropagation()

      // 排除images里面可能包含floor plan images
      // https://7thave.atlassian.net/browse/HT-2567
      const imageTagFloorPlanImage = find(imageTagTidy, item => item.key === 'floor plan')
      const likeFloorplanImages = concat(floorPlanImages, imageTagFloorPlanImage ? imageTagFloorPlanImage.images : [])
      const excludeFloorplanImages = filter(images, item => !likeFloorplanImages.includes(item))

      setGalleryState(d => ({ ...d, show: true, house, images: excludeFloorplanImages, index, floorPlanImages, imageTagTidy, address, showThreeD: false, showVideo: false }))
    }
  }, [setGalleryState])

  // 隐藏图片查看器
  const hideGallery = useCallback(() => {
    resetGalleryState()
  }, [resetGalleryState])

  // 切换当前tag
  const changeCurrentTag = useCallback((tag) => {
    setGalleryState(d => ({ ...d, currentTag: tag, showThreeD: false, showVideo: false }))
  }, [setGalleryState])

  // 从grid点击图片跳转到list
  const jumpToList = useCallback((src) => {
    const { images, floorPlanImages } = state
    const idx = concat(images, floorPlanImages).indexOf(src)
    setGalleryState(d => ({ ...d, currentTag: null, index: idx === -1 ? 0 : idx }))
  }, [setGalleryState, state])

  // 显示3d
  const displayThreeD = useCallback(() => {
    setGalleryState(d => ({ ...d, showThreeD: true, showVideo: false, currentTag: null }))
  }, [setGalleryState])

  // 显示video
  const displayVideo = useCallback(() => {
    setGalleryState(d => ({ ...d, showVideo: true, showThreeD: false, currentTag: null }))
  }, [setGalleryState])

  // useMount(() => {
  //   window.addEventListener('popstate', resetGalleryState)
  //   return () => {
  //     window.removeEventListener('popstate', resetGalleryState)
  //   }
  // })

  return {
    ...state,
    showGallery,
    hideGallery,
    changeCurrentTag,
    jumpToList,
    displayThreeD,
    displayVideo
  }
}